__turbopack_context__.v({
  "circle": "MswBxW_circle" + " " + "MswBxW_shimmerStyles",
  "pill": "MswBxW_pill" + " " + "MswBxW_shimmerStyles",
  "placeholderShimmer": "MswBxW_placeholderShimmer",
  "rectangle": "MswBxW_rectangle" + " " + "MswBxW_shimmerStyles",
  "shimmerStyles": "MswBxW_shimmerStyles",
});
